export default __webpack_public_path__ + "static/media/contact_background_left.225c907d.png";